// extracted by mini-css-extract-plugin
export default {"container":"StartChatMessage_container__CB78R"};